<script setup lang="ts">
import {X} from "@lucide/vue";
import {Button} from "@/core/components/ui/button";
import PhoneChip from "@/rcs/components/try-dialog/shared/PhoneChip.vue";
import StepDialogHeader from "@/rcs/components/try-dialog/shared/StepDialogHeader.vue";

defineProps<{
    formatted: string;
    retrying: boolean;
}>();

defineEmits<{
    (e: 'close'): void;
    (e: 'retry'): void;
}>();
</script>

<template>
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-3">
      <StepDialogHeader :icon="X" bg-class="bg-red-600/20" color-class="text-red-600" />
      <div class="flex flex-col gap-1">
        <h2 class="text-black">
          Une erreur est survenue
        </h2>
        <p class="text-muted-foreground text-sm">
          Nous n'avons pas pu envoyer votre RCS. Aucun crédit n'a été débité - Vous pouvez réessayer.
        </p>
      </div>
      <PhoneChip :phone="formatted" />
      <div class="flex justify-end items-center gap-3">
        <Button variant="outline" @click="$emit('close')">
          Fermer
        </Button>
        <Button class="bg-primary" :disabled="retrying" @click="$emit('retry')">
          Réessayer
        </Button>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
